import { useQuery } from "@tanstack/react-query";
import { resultsApi } from "@/api/results";

// Cross-fleet optics for the active org (Results explorer). Org scoping is by
// the JWT org claim server-side; the query key has no org id, so it must be
// invalidated on org switch (useOrg.setCurrentOrg invalidates everything).
export function useOrgOptics(limit = 200) {
  return useQuery({
    queryKey: ["org-optics", limit],
    queryFn: () => resultsApi.listOrgOptics(limit),
    refetchInterval: 60_000,
  });
}
